<template>
  <div class="application">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        ></vxe-table-column>
      </sirui-table>
    </div>
    <addApp v-on:getData="getData" ref="addApp"></addApp>
    <editApp v-on:getData="getData" ref="editApp"></editApp>
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '../../api/systemManage/application.js';
  import addApp from './addModal/addApp';
  import editApp from './editModal/editApp';

  export default {
    name: 'application',
    mixins: [tableMixins],
    components: {
      addApp,
      editApp,
    },
    data() {
      return {
        query: {
          applicationName: null,
        },
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'applicationName',
            name: this.$t('app.search.applicationName'),
            type: 'input',
            placeholder: this.$t('app.search.appPlaceholder'),
          },
        ];
      },
      columns() {
        return [
          {
            prop: 'applicationName',
            label: this.$t('app.table.applicationName'),
          },
          { prop: 'remark', label: this.$t('app.table.remark') },
        ];
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.menuButtonList = [
          {
            id: 0,
            label: '新增',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-plus',
              buttonName: '新增',
              buttonUrl: 'add',
            },
          },
          {
            id: 1,
            label: '删除',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-delete',
              buttonName: '删除',
              buttonUrl: 'del',
            },
          },
          {
            id: 2,
            label: '修改',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-edit',
              buttonName: '修改',
              buttonUrl: 'edit',
            },
          },
        ];
        // this.getButtons().then(e => {
        //   this.menuButtonList = e;
        // });
      },
      //获取数据
      getData() {
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          this.$refs.addApp.openDialog(true);
        }
        if (type == 'edit') {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('menu.editTreeTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.editApp.openDialog(
            true,
            JSON.parse(JSON.stringify(this.multipleSelection[0]))
          );
        }
        if (type == 'del') {
          if (this.multipleSelection.length == 0) {
            this.$message({
              showClose: true,
              message: this.$t('app.deleteTips'),
              type: 'error',
            });
            return;
          }
          this.$confirmAction()
            .then(() => {
              let applicationCodes = [];
              this.multipleSelection.forEach((item) => {
                applicationCodes.push(item.applicationCode);
              });
              this.loading.startLoading();
              this.$axios
                .post(API.DELETE_APP_API, {
                  applicationList: applicationCodes,
                })
                .then((res) => {
                  this.loading.endLoading();
                  if (0 == res.data.code) {
                    this.$message({
                      type: 'success',
                      message: this.$t('message.success'),
                    });
                    this.getData();
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
    },
  };
</script>
